import * as React from 'react';
import { AUTOMATION_ACTION_TYPE } from '../../../../MedicareProAPI/Entities/Automation/AutomationAction';
import { WebAPI } from '../../../../MedicareProAPI/API/WebAPI';
import { UserLetterRepository } from '../../../../MedicareProAPI/Repositories/User/UserLetterRepository';
import EmptyModal from '../../../Components/EmptyModal';

export interface UserLetterTemplateSelectProps {
  type: AUTOMATION_ACTION_TYPE;
  userAccessToken: string;
  userId: number;

  userLetterTemplateId?: number;

  onUserLetterTemplateIdChange?: (userLetterTemplateId: number) => void;
  onSetupTemplate?: () => void;
  refreshKey?: number;
}

export const UserLetterTemplateSelect = (
  props: UserLetterTemplateSelectProps
): React.JSX.Element => {
  const [type, setType] = React.useState<AUTOMATION_ACTION_TYPE>(props.type);

  const [userLetterTemplateId, setUserLetterTemplateId] = React.useState<number>(
    props.userLetterTemplateId
  );

  const [userLetterTemplates, setUserLetterTemplates] = React.useState<any>([]);
  const [userLetterTemplatesLoading, setUserLetterTemplatesLoading] =
    React.useState<boolean>(false);

  const [isViewingTemplate, setIsViewingTemplate] = React.useState<any>(null);

  const webAPI = new WebAPI();
  webAPI.setAccessToken(props.userAccessToken);

  const userLetterRepository = new UserLetterRepository();
  userLetterRepository.setAccessToken(props.userAccessToken);

  const handleViewSelectedTemplate = (templateId: number) => {
    const selectedTemplate = userLetterTemplates.find(
      (item) => item.value === userLetterTemplateId
    );

    {
      selectedTemplate && setIsViewingTemplate(selectedTemplate);
    }
  };

  React.useEffect(() => {
    setType(props.type);
  }, [props.type]);

  React.useEffect(() => {
    if (type) {
      const sendType = type.substring(5);

      setUserLetterTemplatesLoading(true);

      let templateType;

      if (type === AUTOMATION_ACTION_TYPE.SEND_MAIL) {
        templateType = 'letter';
      } else {
        templateType = sendType;
      }

      userLetterRepository
        .getUserLetters(props.userId, { type: templateType })
        .then((templates) => {
          const newList = Array.from(templates.getItems(), (item) => {
            return {
              value: item.getLetterId(),
              label: item.getLetterTitle(),
              content: item.getLetterBody(),
            };
          });

          setUserLetterTemplates(newList);
          setUserLetterTemplatesLoading(false);
        });
    }
  }, [type, props.refreshKey]);

  const userLetterTemplateChange = (event: React.SyntheticEvent) => {
    const inputElement = event.target as HTMLFormElement;
    const inputValue = parseInt(inputElement.value);

    if (props.onUserLetterTemplateIdChange) {
      props.onUserLetterTemplateIdChange(inputValue);
    }

    setUserLetterTemplateId(inputValue);
  };

  return (
    <>
      {userLetterTemplatesLoading === true && (
        <div className="alert small alert-info" role="alert">
          <i className="fas fa-spinner fa-spin ml-2"></i> Loading....
        </div>
      )}
      {userLetterTemplatesLoading === false && userLetterTemplates.length === 0 && (
        <div className="alert small alert-info" role="alert">
          No templates available
          <br></br>
          {type !== AUTOMATION_ACTION_TYPE.SEND_MAIL && (
            <div
              className="badge badge-pill badge-info cp"
              style={{ fontSize: '8pt' }}
              onClick={props.onSetupTemplate}
            >
              <i className="far fa-plus-circle"></i> Make a template
            </div>
          )}
        </div>
      )}
      {userLetterTemplatesLoading === false && userLetterTemplates.length > 0 && (
        <>
          <div className="input-group input-group-sm">
            <select
              name="userLetterTemplateId"
              value={userLetterTemplateId}
              onChange={userLetterTemplateChange}
              className="form-control form-control-sm"
            >
              <option value={''}>None</option>
              {userLetterTemplates.length > 0 &&
                userLetterTemplates.map((item) => <option value={item.value}>{item.label}</option>)}
            </select>
          </div>
        </>
      )}
      {userLetterTemplates.length > 0 && (
        <div
          className="badge badge-pill badge-info cp"
          style={{ fontSize: '8pt' }}
          onClick={props.onSetupTemplate}
        >
          <i className="far fa-plus-circle"></i> Make/Edit
        </div>
      )}
      {userLetterTemplates.length > 0 && userLetterTemplateId > 0 && (
        <>
          <div
            className="badge badge-pill badge-primary ml-2 cp"
            style={{ fontSize: '8pt' }}
            onClick={() => handleViewSelectedTemplate(userLetterTemplateId)}
          >
            <i className="far fa-eye"></i> Preview
          </div>
        </>
      )}
      {isViewingTemplate && type === AUTOMATION_ACTION_TYPE.SEND_SMS && (
        <EmptyModal
          size="md"
          title={isViewingTemplate.label}
          footerCloseButton={true}
          show={isViewingTemplate !== null}
          onClose={(e) => setIsViewingTemplate(false)}
        >
          <div className="iphone-sms-mock">
            <div className="iphone-sms-header">Messages</div>

            <div className="iphone-sms-body">
              <div className="iphone-sms-bubble sent">
                <div dangerouslySetInnerHTML={{ __html: isViewingTemplate.content }} />
              </div>
            </div>

            <div className="iphone-sms-footer">
              <div className="iphone-sms-plus">
                <i className="far fa-plus-circle text-secondary"></i>
              </div>
              <div className="iphone-sms-input">Text Message - SMS</div>
              <div className="iphone-sms-mic">
                <i className="far fa-microphone text-secondary"></i>
              </div>
            </div>
          </div>
        </EmptyModal>
      )}

      {isViewingTemplate && type === AUTOMATION_ACTION_TYPE.SEND_EMAIL && (
        <EmptyModal
          size="md"
          title={isViewingTemplate.label}
          footerCloseButton={true}
          show={isViewingTemplate !== null}
          onClose={(e) => setIsViewingTemplate(false)}
        >
          <div className="email-mockup modern">
            <div className="email-mockup-header modern">
              <div className="mockup-placeholder-bar short"></div>
              <div className="mockup-placeholder-bar"></div>
              <div className="placeholder-mockup-bar medium"></div>
            </div>
            <div className="email-mockup-body">
              <div dangerouslySetInnerHTML={{ __html: isViewingTemplate.content }} />
            </div>
          </div>
        </EmptyModal>
      )}
    </>
  );
};
